import { degToRad, RAD2DEG, radToDeg } from 'three/src/math/MathUtils.js';

interface KalmanFilter1D {
  x: number; // current state (roll estimate)
  p: number; // current estimate covariance
  q: number; // process noise covariance
  r: number; // measurement noise covariance
}

function createKalmanFilter1D(initialMeasurement: number, processNoise: number, measurementNoise: number): KalmanFilter1D {
  return {
    x: initialMeasurement,
    p: 1,
    q: processNoise,
    r: measurementNoise,
  };
}

function kalmanUpdate(filter: KalmanFilter1D, measurement: number): number {
  // Prediction update (no control input, so state remains same)
  filter.p += filter.q;
  
  // Measurement update
  const k = filter.p / (filter.p + filter.r);
  filter.x = filter.x + k * (measurement - filter.x);
  filter.p = (1 - k) * filter.p;
  
  return filter.x;
}

function processRollAverageKalman(framesnormalized: any[]) {
  // Use a single Kalman filter for sequential processing:
  const processNoise = 0.01;       // Tune based on process dynamics
  const measurementNoise = 0.1;    // Tune based on measurement noise
  // Initialize the Kalman filter with the first roll value.
  const firstRoll = framesnormalized[0].euler!.z;
  const kalman = createKalmanFilter1D(firstRoll, processNoise, measurementNoise);
  
  framesnormalized.forEach((frame, index) => {
    const rollMeasurement = frame.euler!.z;
    const smoothedRoll = kalmanUpdate(kalman, rollMeasurement);
    frame.rollaverage = smoothedRoll;
    console.log("smoothed roll (rollaverage)", radToDeg(smoothedRoll));
  });
}

function processRollAverage(framesnormalized: any[], windowSize: number = 15) {
  // This basic roll average computes a simple moving average over a window of frame roll values.
  const halfWindow = Math.floor(windowSize / 2);
  for (let i = 0; i < framesnormalized.length; i++) {
    let sum = 0;
    let count = 0;
    const start = Math.max(0, i - halfWindow);
    const end = Math.min(framesnormalized.length - 1, i + halfWindow);
    for (let j = start; j <= end; j++) {
      // Use the roll measurement from the Euler angle (z component)
      sum += framesnormalized[j].euler!.z;
      count++;
    }
    framesnormalized[i].rollaverage = sum / count;
    console.log("basic roll average", radToDeg(framesnormalized[i].rollaverage));
  }
}

export { processRollAverage, processRollAverageKalman };